import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Nav({ onGetStarted }) {
  const [hovered, setHovered] = useState(null);
  const links = [
    ["The Problem", "#problem"],
    ["Ecosystem", "#ecosystem"],
    ["Offering", "#offering"],
    ["How it works", "#how"],
    ["Pricing", "#pricing"],
    ["Contact", "#contact"],
  ];
  return (
    <motion.header
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      data-testid="main-nav"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="https://lypinn.com/brand/lypinn-icon-1024.png" alt="LyPinn" className="w-8 h-8 rounded-md" />
          <span className="font-display font-bold tracking-tight text-lg">
            LYPINN <span className="text-[#E5FF00]">PULSE</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              onMouseEnter={() => setHovered(href)}
              onMouseLeave={() => setHovered(null)}
              className="relative font-mono-tech text-[11px] tracking-[0.2em] text-zinc-400 hover:text-white transition-colors duration-200"
              data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {label.toUpperCase()}
              <motion.span
                className="absolute -bottom-1 left-0 h-px bg-[#E5FF00]"
                initial={false}
                animate={{ width: hovered === href ? "100%" : "0%" }}
                transition={{ duration: 0.25 }}
              />
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={onGetStarted}
            className="flex items-center gap-1.5 bg-[#E5FF00] text-black font-display font-bold text-xs tracking-wide px-5 py-2.5 hover:bg-white transition-colors duration-200"
            data-testid="nav-get-started-btn"
          >
            GET STARTED <ArrowUpRight size={14} />
          </button>
        </div>
      </div>
    </motion.header>
  );
}
